import { createFileRoute } from "@tanstack/react-router";

import ResetPassword from "@/features/auth/ResetPassword";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/reset-password")({
  component: () => (
    <BasicLayout>
      <ResetPassword />
    </BasicLayout>
  ),
});
